"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const colors_1 = require("../themes/colors");
const styled_1 = require("./styled");
const Badge = ({ design: style, children }) => {
    switch (style) {
        case 'pending':
            return (react_1.default.createElement(styled_1.BadgeWrapper, { small: true, color: colors_1.colors.shade90, background: colors_1.colors.primaryBlue25 }, children));
        case 'waiting':
            return (react_1.default.createElement(styled_1.BadgeWrapper, { small: true, color: colors_1.colors.shade80, background: colors_1.colors.shade30 }, children));
        case 'warning':
            return (react_1.default.createElement(styled_1.BadgeWrapper, { small: true, color: colors_1.colors.shade90, background: colors_1.colors.yellow25 }, children));
        case 'error':
            return (react_1.default.createElement(styled_1.BadgeWrapper, { small: true, color: colors_1.colors.shade90, background: colors_1.colors.red25 }, children));
        default:
            return (react_1.default.createElement(styled_1.BadgeWrapper, { small: true, color: colors_1.colors.shade90, background: colors_1.colors.green25 }, children));
    }
};
exports.default = Badge;
//# sourceMappingURL=Badge.js.map